// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"133d91c3","732":"6b15b279","977":"1d15979b"}[chunkId] + ".chunk.js";
};